import axios from '@/libs/api.request';

export const getSuggestionList = data => {
    return axios.request({
        url: 'api/systemManagement/suggestionManagement/getSuggestionList',
        data: data,
        method: 'post'
    });
};

export const saveSuggestion = data => {
    return axios.request({
        url: 'api/systemManagement/suggestionManagement/saveSuggestion',
        data: data,
        method: 'post'
    });
};
